export enum PaymentErrorsEnum {
  INSUFFICIENT_AMOUNT = 'insufficientAmount',
  TRANSACTION_ERROR = 'transactionError',
  TRANSACTION = 'transaction',
  ANTIFRAUD = 'antifraud',
  EXPIRED = 'expired',
  CARD_NOT_VALID_FOR_THIS_OPERATION = 'cardNotValidForThisOperation',
}

export enum PaymentErrorPathsEnum {
  ORDER_ID = 'orderId',
  SALE_ID = 'saleId',
  DIRECT_LINK_ID = 'directLinkId',
  PAYMENT_ID = 'paymentId',
  PAYMENT_CARD = 'paymentCard',
  PAYMENT_CARD_CARD_NUMBER = 'paymentCard.cardNumber',
}

export type PaymentValidationErrorFlags = {
  isPurchaseDisapproved: boolean;
  isGatewaysMismatch: boolean;
  isBlockedBuyer: boolean;
  hasInsufficientAmount: boolean;
};

export enum CheckoutErrorsEnum {
  ANTIFRAUD = 'checkout_payment_anti_fraud_error',
  TRANSACTION = 'checkout_payment_transaction_error',
  UNAUTHORIZED = 'checkout_payment_unauthorized_error',
  GENERIC = 'checkout_payment_generic_transaction_error',
}

export type {
  PaymentBrand,
  PaymentOption,
  PaymentCardParams,
  PaymentFingerprint,
  PaymentAuthSettings,
  PaymentInstallmentOption,
  Address,
  CurrencyInfo,
  PaymentMethodExternalAuthentication,
} from '@src/core/buyerApiClient';

export {
  PaymentMethodCode,
  PaymentAuthSettingsExecutionRule,
  ExternalAuthenticationProviderType,
} from '@src/core/buyerApiClient';
